// extracted by mini-css-extract-plugin
export default {"meeting_room_hero_image":"indes_meeting_room_hero_image__08Utt"};